export default __webpack_public_path__ + "static/media/erythree_carte_4-min.2aed2f1f.png";